<template>
  <v-app>
    <router-view></router-view>
    <!-- global snackbar -->
    <v-snackbar
      :timeout="3000"
      app
      bottom
      left
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      rightDrawer: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }
  },
  computed: {
    ...mapGetters(['appSavitarna']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isDevelop() {
      return process.env.VUE_APP_LOCAL === 'develop'
    },
    isTest() {
      return process.env.VUE_APP_LOCAL === 'test'
    },
  },
  created() {
    this.$on('SHOW_SNACKBAR', e => {
      this.snackbar = {
        show: true,
        text: e.text,
        color: e.color,
      }
    })
    this.$on('AUTH_FAILED', e => {
      if (this.appSavitarna) {
        window._VMA.$emit('SAV_SESSION_ERROR')
      } else {
        this.$router.push({ name: 'login' })
      }
    })
    this.$on('SERVER_ERROR', () => {
      this.snackbar = {
        show: true,
        text: this.$t('Serverio klaida'),
        color: 'error',
      }
    })
    this.$on('FORMAT_ERROR', () => {
      this.snackbar = {
        show: true,
        text: this.$t(
          'Neužpildyti visi privalomi laukai arba netinkamas laukų formatas.'
        ),
        color: 'error',
      }
    })
    this.$on('DOCUMENT_ERROR', () => {
      this.snackbar = {
        show: true,
        text: this.$t(
          'Netinkamas dokumento formatas, galima įkelti tik PDF, ADOC ir ASICE.'
        ),
        color: 'error',
      }
    })
    this.$on('DATA_ERROR', message => {
      this.snackbar = {
        show: true,
        text: message,
        color: 'error',
      }
    })
    this.$on('DATA_OK', message => {
      this.snackbar = {
        show: true,
        text: message,
        color: 'success',
      }
    })
    this.$on('SAV_LOGIN_ERROR', () => {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}`
    })
    this.$on('SAV_SESSION_ERROR', () => {
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}showError.do?errorView=errorSessionExpire`
    })
  },
  mounted() {
    if (typeof window !== undefined && window._VMA === undefined) {
      window._VMA = this
    }
  },
}
</script>
